import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

import Button from '../Controls/Button/Button';

import styles from './EulaPopup.module.css';
import { httpGet, httpPost } from '../../../utils';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

const blueButton = {
    color: '#ffffff',
    backgroundColor: '#188ded',
    padding: '4px 16px',
    boxShadow: 'none',
    marginRight: '20px',
    marginLeft: '40px',
    marginTop: '10px',
    marginBottom: '10px'
};

const redButton = {
    color: 'rgba(234, 17, 63, 0.8)',
    backgroundColor: '#ffffff',
    boxShadow: 'none',
    border: '1px solid',
    borderColor: 'rgba(234, 17, 63, 0.8)',
    padding: '4px 16px'
};

const EulaPopup = ({ onAgree, onDisagree, readOnly, logoutOnDisagree }) => {
    const [eula, setEula] = useState({ __html: '' });

    useEffect(() => {
        const loadEula = async () => {
            const { data } = await httpGet('/SilverfortLicenseAgreement.html', { [HTTP_OPTIONS.HANDLE_ERRORS]: true });
            if (data) setEula({ __html: data });
        };

        loadEula();
    }, []);

    const agree = async () => {
        try {
            await httpPost('/Settings/eulaAgree');
            onAgree(true);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Modal dialogClassName="modal-lg" show onHide={onDisagree} backdrop="static">
            <Modal.Header closeButton>
                <div className={styles.header}>{'SILVERFORT - License Terms & Conditions'}</div>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.eula}>
                    <div className={styles.eulaContent} dangerouslySetInnerHTML={eula}></div>
                </div>
            </Modal.Body>
            <Modal.Footer className={`items-center justify-between ${readOnly ? 'block' : 'flex'}`}>
                <div className={styles.hint}>
                    If you have a separate agreement in place with Silverfort, please click 'I agree' to proceed with
                    installing, and the version presented here will not apply (see 2nd paragraph)
                </div>
                {!readOnly && (
                    <div className={styles.buttons}>
                        <Button
                            style={redButton}
                            onClick={
                                logoutOnDisagree
                                    ? () => {
                                          window.location.href = '/logout';
                                      }
                                    : onDisagree
                            }>
                            {logoutOnDisagree ? 'Logout' : "I Don't Agree"}
                        </Button>
                        <Button style={blueButton} onClick={agree}>
                            I Agree
                        </Button>
                    </div>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EulaPopup;
